import { createContext, useContext } from 'react';
import { Placement } from '../types';

export type PlacementSelectorContextState = {
  activePlacementsLoading: boolean;
  /** List of all active (non-archived) placements. */
  activePlacementsList: Placement[];
  allPlacementsLoading: boolean;
  /** List of all placements, including archived. */
  allPlacementsList: Placement[];
  /** Whether selected placement is archived, evaluated from `selectedPlacementDetails`. */
  isSelectedPlacementArchived: boolean;
  selectedPlacementDetails: Placement | undefined;
  selectedPlacementId: number | undefined;
};

export const PlacementSelectorContext = createContext<PlacementSelectorContextState>({
  activePlacementsLoading: false,
  activePlacementsList: [],
  allPlacementsLoading: false,
  allPlacementsList: [],
  isSelectedPlacementArchived: false,
  selectedPlacementDetails: undefined,
  selectedPlacementId: undefined,
});

export const usePlacementSelectorContext = () => useContext(PlacementSelectorContext);
